import React from 'react'
import PropTypes from 'prop-types'
import { View, Text } from '@react-pdf/renderer'

// Styling
import { globalStyles } from '../../Styles'

const renderResults = (data, category) => {
    return (
		<View key={`${category}-result`} style={globalStyles.detailContent}>
        	<Text>
            	{`Data Provided for ${category}\n`}
            </Text>
            {data.map((element, index) => {
				if( !element.hasOwnProperty('dependency') ) {
					const value = element.value === null ? 'Not provided' : element.value
	        	    return (
		               	<View key={`${element.fullDatabaseFieldName}-wrapper`}>
        	               	<Text key={`${element.fullDatabaseFieldName}-label`} style={globalStyles.text}>
								{`${element.field_label}: ${value}`}
    	        	        </Text>
                   		</View>
    	        	)
				}
			})}
		</View>
    )

}
// -----------------------------------------------------------------------------
// RENDER PANEL RESULTS:

// This renders ALL order panels - (Panel header and mutations)
// - Panel header includes: Panel name and panel notes / summary
// - Panel Mutations
// -----------------------------------------------------------------------------
const Results = ({ results, id }) => {
    return (
		<View style={globalStyles.result} >
			{Object.keys(results).map(category => {
				return (
					<View style={globalStyles.section} key={`${category}-wrapper`}>
						<View break key={category} style={globalStyles.pageHeaderContainer} >
							<Text style={globalStyles.pageHeader} >
								ID: {id}
							</Text>
							<Text style={[globalStyles.pageHeader, globalStyles.smHeader]} >
								{category}
							</Text>
						</View>
						<View style={globalStyles.detailContentContainer} >
					        { renderResults(results[category].records.columns, category) }
	    		        </View>
					</View>
				)
			})}
		</View>
    )
}

// Define propTypes
Results.propTypes = {
	panelResults: PropTypes.array,
}

// Export Summary Component
export default Results
